export const selfServiceMigration = 'Self-Service Migration';
